import React from "react";
import { useParams } from "react-router-dom";
import Logo from "../../image/Logo.png";
import DisplayQuestion from "../../part/user/display_exam_question";



const ExamQuestion = () => {
    const { course_id } = useParams();
    return (
        <div className="dashboard">
            <header className="dash_header" >
                <img src={Logo} alt="logo" className="logo" style={{ marginLeft: "5%" }} />
                <h2 className="company_name" >GEOINFOTECH <br />  <span>ACADEMY</span></h2>
                {/* <button className="payment right" onClick={this.handleOnlineRedirect}>Online Courses</button>
                <button className="payment right" onClick={this.handlePhysicalRedirect}>Physical Courses</button> */}
            </header>

            <DisplayQuestion exam_id = {course_id}/>

        </div>
    )
}

export default ExamQuestion